// solid background

import React from "react";
import { connect } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import LogoutAuthAction from "../redux/actions/LogoutAuthAction";

// JavaScript plugin that hides or shows a component based on your scroll
import Headroom from "headroom.js";
// reactstrap components
import {
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
} from "reactstrap";
// core components

function InfoNavbar(props) {
  const { states, logout } = props;
  const auth = states.auth;
  const history = useHistory();

  const [bodyClick, setBodyClick] = React.useState(false);
  const [collapseOpen, setCollapseOpen] = React.useState(false);
  React.useEffect(() => {
    let headroom = new Headroom(document.getElementById("navbar-main"));
    // initialise
    headroom.init();
  });

  function Greeting() {
    if (auth.isLoggedIn) {
      return <Nav className="ml-auto" navbar>
          <NavItem>
            <NavLink href="/index">
              Home
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink href="/settings" >Settings</NavLink>
          </NavItem>
          <NavItem>
          <NavLink href="#" onClick={()=>{logout(history)} }>Logout</NavLink>
          </NavItem>
        </Nav>;
    }
    return <Nav className="ml-auto" navbar>
        <NavItem>
          <NavLink href="/index">
            Home
          </NavLink>
        </NavItem>
        <NavItem>
        <NavLink href="/auth" >Sign Up / Log In</NavLink>
        </NavItem>
      </Nav>;
  }

  return (
    <>
      {bodyClick ? (
        <div
          id="bodyClick"
          onClick={() => {
            document.documentElement.classList.toggle("nav-open");
            setBodyClick(false);
            setCollapseOpen(false);
          }}
        />
      ) : null}
      <Navbar className="fixed-top" expand="lg" id="navbar-main" color="info">
        <Container>
          <div className="navbar-translate">
          <NavbarBrand id="navbar-brand" to="/index" tag={Link}>
              <div
                style={{
                  backgroundImage:
                    "url(" +
                    require("assets/images/logo.svg").default +
                    ")",
                    width: "144px",
                    height: "45px",
                }}
              >&nbsp;</div>
            </NavbarBrand>
            <button
              className="navbar-toggler"
              id="navigation"
              type="button"
              onClick={() => {
                document.documentElement.classList.toggle("nav-open");
                setBodyClick(true);
                setCollapseOpen(true);
              }}
            >
              <span className="navbar-toggler-bar bar1" />
              <span className="navbar-toggler-bar bar2" />
              <span className="navbar-toggler-bar bar3" />
            </button>
          </div>
          <Collapse navbar isOpen={collapseOpen}>
            <Greeting />
          </Collapse>
        </Container>
      </Navbar>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    states: state,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    logout: (history) => {
      dispatch(LogoutAuthAction(history));

    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(InfoNavbar);
